import setVariantUrl from "../utils/setVariantUrl";
import setParamUrl from "../utils/setParamUrl";
import getHTML from "../utils/getHTML";

const updateForm = async (variant, extraOptions, $container: HTMLElement | null = null) => {
  const $productTemplate = $container || document.querySelector(
    "[theme-product-template]"
  ) as HTMLElement;
  const id = $productTemplate.dataset.id;
  if (!$productTemplate || !id) {
    return;
  }

  // change URL

  setVariantUrl(variant.id); // variant id
  const url = new URLSearchParams(window.location.search);

  // loop throught extraOptions object and add extra options to url

  for (const [key, value] of Object.entries(extraOptions)) {
    url.set(key, value);
    setParamUrl(key, value);
  }

  // fetch updated product template

  url.set("section_id", id);
  const html = await getHTML(window.location.pathname + "?" + url.toString());

  const $newHTML = html.querySelector(
    "[theme-product-template]"
  ) as HTMLElement;

  if (!$newHTML) {
    console.error("New product template not found in response", html.body.innerHTML);
    return;
  }

  // insert new html in dom

  $productTemplate.replaceWith($newHTML);

  // dispatch event to set new event listeners

  const event = new CustomEvent("product-template-update");
  document.dispatchEvent(event);
};

export default updateForm;
